import { getAllContratadoAnoPedidoMaterialLog, IContratadoAnoPedidoMaterialLog, processarPendenciaContratadoAnoPedidoMaterial } from '@app/api/orcadoAnoMes';
import {
    Button,
    Col,
    Form,
    FormInput,
    FormResetButton,
    GridView,
    Row,
    SimpleView,
    Table,
    Widget,
} from '@digital/ui';
import { Collapse, Icon } from 'antd';
import React, { useEffect, useState } from 'react';
const { Panel } = Collapse;



const LogContratadoAno = () => {
    const [allContratadoAnoTipoMaterial, setContratadoAnoMaterial] = useState<Array<IContratadoAnoPedidoMaterialLog>>();

    useEffect(() => {
        getAll();
    }, []);

    const getAll = async () => {
        const allContratadoAnoMateria = await getAllContratadoAnoPedidoMaterialLog();
        if (allContratadoAnoMateria)
            setContratadoAnoMaterial(allContratadoAnoMateria)
    }

    const colums = () => {
        return [
            {
                title: 'N',
                dataIndex: 'index',
                with: '2%',
            },
            {
                title: 'Código PROJETO',
                dataIndex: 'codigoProjeto',
                align: 'center',
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <Form>
                        <Row>
                            <FormInput
                                placeholder="Pesquisar Contrato/PCs"
                                name="codigoProjeto"
                                style={{ marginTop: '15px' }}
                                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                onPressEnter={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                            />
                        </Row>
                        <Row>
                            <Col span={6}>
                                <Button
                                    type="primary"
                                    style={{ marginLeft: '5px' }}
                                    onClick={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                    icon="commons-search"
                                    size="small">
                                    Pesquisar
                                </Button>
                            </Col>
                            <Col span={6}>
                                <FormResetButton
                                    size="small"
                                    style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                    beforeReset={() => {
                                        if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                    }}>
                                    Limpar
                                </FormResetButton>
                            </Col>
                        </Row>
                    </Form>
                ),
                filterIcon: filtered => {
                    const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                    return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                },
                onFilter: (value, record) => {
                    try {
                        if (record != undefined
                            && record.hasOwnProperty('codigoProjeto')
                            && record.codigoProjeto != null) {
                            return record.codigoProjeto
                                .toString()
                                .toLowerCase()
                                .includes(value.toLowerCase())
                        }
                    } catch (e) {
                        // console.log('catch', record.codigoProjeto);
                    }
                    return false;
                }
            },
            {
                title: 'Código Pacote',
                dataIndex: 'codigoPacote',
                align: 'center',
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <Form>
                        <Row>
                            <FormInput
                                placeholder="Pesquisar Contrato/PCs"
                                name="codigoPacote"
                                style={{ marginTop: '15px' }}
                                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                onPressEnter={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                            />
                        </Row>
                        <Row>
                            <Col span={6}>
                                <Button
                                    type="primary"
                                    style={{ marginLeft: '5px' }}
                                    onClick={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                    icon="commons-search"
                                    size="small">
                                    Pesquisar
                                </Button>
                            </Col>
                            <Col span={6}>
                                <FormResetButton
                                    size="small"
                                    style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                    beforeReset={() => {
                                        if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                    }}>
                                    Limpar
                                </FormResetButton>
                            </Col>
                        </Row>
                    </Form>
                ),
                filterIcon: filtered => {
                    const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                    return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                },
                onFilter: (value, record) => {
                    try {
                        if (record != undefined
                            && record.hasOwnProperty('codigoPacote')
                            && record.codigoPacote != null) {
                            return record.codigoPacote
                                .toString()
                                .toLowerCase()
                                .includes(value.toLowerCase())
                        }
                    } catch (e) {
                        // console.log('catch', record.codigoPacote);
                    }
                    return false;
                }
            },
            {
                title: 'NÚMERO ORDEM COMPRA',
                dataIndex: 'ordemCompraNumero',
                align: 'center',
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <Form>
                        <Row>
                            <FormInput
                                placeholder="Pesquisar Contrato/PCs"
                                name="ordemCompraNumero"
                                style={{ marginTop: '15px' }}
                                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                onPressEnter={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                            />
                        </Row>
                        <Row>
                            <Col span={6}>
                                <Button
                                    type="primary"
                                    style={{ marginLeft: '5px' }}
                                    onClick={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                    icon="commons-search"
                                    size="small">
                                    Pesquisar
                                </Button>
                            </Col>
                            <Col span={6}>
                                <FormResetButton
                                    size="small"
                                    style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                    beforeReset={() => {
                                        if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                    }}>
                                    Limpar
                                </FormResetButton>
                            </Col>
                        </Row>
                    </Form>
                ),
                filterIcon: filtered => {
                    const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                    return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                },
                onFilter: (value, record) => {
                    try {
                        if (record != undefined
                            && record.hasOwnProperty('ordemCompraNumero')
                            && record.ordemCompraNumero != null) {
                            return record.ordemCompraNumero
                                .toString()
                                .toLowerCase()
                                .includes(value.toLowerCase())
                        }
                    } catch (e) {
                        // console.log('catch', record.ordemCompraNumero);
                    }
                    return false;
                }

            },
            {
                title: 'Número PCM',
                dataIndex: 'pcmNumero',
                align: 'center',
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <Form>
                        <Row>
                            <FormInput
                                placeholder="Pesquisar Contrato/PCs"
                                name="pcmNumero"
                                style={{ marginTop: '15px' }}
                                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                onPressEnter={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                            />
                        </Row>
                        <Row>
                            <Col span={6}>
                                <Button
                                    type="primary"
                                    style={{ marginLeft: '5px' }}
                                    onClick={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                    icon="commons-search"
                                    size="small">
                                    Pesquisar
                                </Button>
                            </Col>
                            <Col span={6}>
                                <FormResetButton
                                    size="small"
                                    style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                    beforeReset={() => {
                                        if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                    }}>
                                    Limpar
                                </FormResetButton>
                            </Col>
                        </Row>
                    </Form>
                ),
                filterIcon: filtered => {
                    const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                    return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                },
                onFilter: (value, record) => {
                    try {
                        if (record != undefined
                            && record.hasOwnProperty('pcmNumero')
                            && record.pcmNumero != null) {
                            return record.pcmNumero
                                .toString()
                                .toLowerCase()
                                .includes(value.toLowerCase())
                        }
                    } catch (e) {
                        // console.log('catch', record.pcmNumero);
                    }
                    return false;
                }
            },
            {
                title: 'Requisitado Ano',
                dataIndex: 'anoRequisicaoCompra',
                align: 'center',
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <Form>
                        <Row>
                            <FormInput
                                placeholder="Pesquisar Contrato/PCs"
                                name="anoRequisicaoCompra"
                                style={{ marginTop: '15px' }}
                                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                onPressEnter={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                            />
                        </Row>
                        <Row>
                            <Col span={6}>
                                <Button
                                    type="primary"
                                    style={{ marginLeft: '5px' }}
                                    onClick={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                    icon="commons-search"
                                    size="small">
                                    Pesquisar
                                </Button>
                            </Col>
                            <Col span={6}>
                                <FormResetButton
                                    size="small"
                                    style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                    beforeReset={() => {
                                        if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                    }}>
                                    Limpar
                                </FormResetButton>
                            </Col>
                        </Row>
                    </Form>
                ),
                filterIcon: filtered => {
                    const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                    return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                },
                onFilter: (value, record) => {
                    try {
                        if (record != undefined
                            && record.hasOwnProperty('anoRequisicaoCompra')
                            && record.anoRequisicaoCompra != null) {
                            return record.anoRequisicaoCompra
                                .toString()
                                .toLowerCase()
                                .includes(value.toLowerCase())
                        }
                    } catch (e) {
                        // console.log('catch', record.anoRequisicaoCompra);
                    }
                    return false;
                }
            },
            {
                title: 'Requisitado Ano Quantidade',
                dataIndex: 'requisitadoAnoQuantidade',
                align: 'center',
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <Form>
                        <Row>
                            <FormInput
                                placeholder="Pesquisar Contrato/PCs"
                                name="requisitadoAnoQuantidade"
                                style={{ marginTop: '15px' }}
                                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                onPressEnter={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                            />
                        </Row>
                        <Row>
                            <Col span={6}>
                                <Button
                                    type="primary"
                                    style={{ marginLeft: '5px' }}
                                    onClick={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                    icon="commons-search"
                                    size="small">
                                    Pesquisar
                                </Button>
                            </Col>
                            <Col span={6}>
                                <FormResetButton
                                    size="small"
                                    style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                    beforeReset={() => {
                                        if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                    }}>
                                    Limpar
                                </FormResetButton>
                            </Col>
                        </Row>
                    </Form>
                ),
                filterIcon: filtered => {
                    const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                    return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                },
                onFilter: (value, record) => {
                    try {
                        if (record != undefined
                            && record.hasOwnProperty('requisitadoAnoQuantidade')
                            && record.requisitadoAnoQuantidade != null) {
                            return record.requisitadoAnoQuantidade
                                .toString()
                                .toLowerCase()
                                .includes(value.toLowerCase())
                        }
                    } catch (e) {
                        // console.log('catch', record.requisitadoAnoQuantidade);
                    }
                    return false;
                }
            },
        ];
    };

    return (
        <SimpleView>
            <GridView noform>
                <Widget
                    title="LOG CONTRATADO ANO MES - TIPO MATERIAL"
                    actions={
                        [
                            <Button
                                type="link"
                                title="PROCESSAR PENDENCIAS"
                                icon="data-add_column"
                                onClick={() => {
                                    processarPendenciaContratadoAnoPedidoMaterial().then(() => {
                                        getAll();
                                    });
                                }}
                            />,
                        ]}>
                    <Table
                        columns={colums()}
                        dataSource={allContratadoAnoTipoMaterial}
                    />
                </Widget>
            </GridView>
        </SimpleView>
    );
};

export default LogContratadoAno;
